module.exports = __webpack_public_path__ + "media/06 the Double Ninth Festival.7d8f49f0.mp3";